"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addItemLimiter = exports.removeItem = exports.updateItem = exports.addItemAt = exports.addItems = exports.addItemsAt = exports.addItem = exports.dummyObject = exports.dummyArray = void 0;
exports.dummyArray = [];
exports.dummyObject = {};
const addItem = (array = [], item) => [...array, item];
exports.addItem = addItem;
const addItemsAt = (array = [], itemsArr, position) => [
    ...array.slice(0, position),
    ...itemsArr,
    ...array.slice(position),
];
exports.addItemsAt = addItemsAt;
const addItems = (array = [], item, position) => (0, exports.addItemsAt)(array, [item], position);
exports.addItems = addItems;
const addItemAt = (array = [], item, position) => [
    ...array.slice(0, position),
    item,
    ...array.slice(position + 1),
];
exports.addItemAt = addItemAt;
const updateItem = (array = [], item = { id: null }) => array.map((oItem) => (oItem.id === item.id ? item : oItem));
exports.updateItem = updateItem;
const removeItemById = (array = [], id) => {
    return array.filter((item) => item.id !== id);
};
const removeItemId = (array = [], id) => {
    const index = array.indexOf(id);
    if (index !== -1) {
        return [...array.slice(0, index), ...array.slice(index + 1)];
    }
    return array;
};
const removeItem = (array = [], itemOrId) => {
    const itemType = typeof itemOrId;
    if (itemType === 'string') {
        return removeItemId(array, itemOrId);
    }
    if (itemOrId.id) {
        return removeItemById(array, itemOrId.id);
    }
    return [...array];
};
exports.removeItem = removeItem;
const addItemLimiter = (array = [], item, limit = 1) => array.length < limit && !~array.indexOf(item) ? [...array, item] : array;
exports.addItemLimiter = addItemLimiter;
//# sourceMappingURL=immutable-reducers.js.map